import React from 'react'
import {  AppBar, Tabs, Tab, makeStyles } from '@material-ui/core'
import { Link, useLocation, Redirect, Switch, useRouteMatch } from 'react-router-dom'
import PropTypes from 'prop-types'
import PrivateRoute from 'components/App/PrivateRoute'
import BannerLoader from 'components/App/BannerLoader'


const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.primary.dark,
    marginTop: '-1px'
  },
  tabs: {
    height: '56px', // Matches height of main nav bar
  }
}))

export default function TabbedRoutes({ routes }) {
  const { pathname: currentPath } = useLocation()
  const classes = useStyles()
  const { path: parentRoute } = useRouteMatch()

  if (currentPath === parentRoute) {
    return <Redirect to={`${parentRoute}/${routes[0].path}`} />
  }

  const fullPath = (nestedPath) => `${parentRoute}/${nestedPath}`

  return (
    <div>
      <AppBar elevation={0} position='sticky' className={classes.appBar}>
        <Tabs value={currentPath} centered className={classes.tabs}>
          {routes.map(({ path, label }, index) => (
            <Tab key={index} component={Link} value={fullPath(path)} to={fullPath(path)} label={label} />
          ))}
        </Tabs>
      </AppBar>

      <BannerLoader />
      <Switch>
        {routes.map(({ path, component }, index) => (
          <PrivateRoute key={index} exact path={fullPath(path)} component={component} />  
        ))}
      </Switch>
    </div>
  )
}

TabbedRoutes.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired
    })
  ).isRequired
}


